/* eslint-disable no-console */
export const state = () => ({
  annualLoading: false,
  annualSuccess: '',
  annualError: '',
})

export const getters = {
  annualLoading(state) {
    return state.annualLoading
  },
  annualSuccess(state) {
    return state.annualSuccess
  },
  annualError(state) {
    return state.annualError
  },
}

export const mutations = {
  SET_ANNUAL_LOADING: (state, isLoading) => {
    state.annualLoading = isLoading
  },
  SET_ANNUAL_SUCCESS: (state, success) => {
    state.annualSuccess = success
  },
  SET_ANNUAL_ERROR: (state, error) => {
    state.annualError = error
  },
}

export const actions = {
  async annual({ commit }, { quoteId, cardDetails }) {
    commit('SET_ANNUAL_LOADING', true)
    try {
      const data = await this.$axios.$post(
        `/api/policy/v1/pay/${quoteId}/annually`,
        {
          card: cardDetails,
        }
      )
      this.$toast.success(`Success payment ${data.policy_code}`)
      this.$gtm.push({
        event: 'purchase_complete',
        payment_type: 'annually',
        transactionId: data.policy_code,
        transactionTotal: data.payment_type_amount,
        'prices.total_discounted': data.payment_type_amount,
        policy_total: data.payment_type_amount,
        prices: {
          discount_percent: data.discount_percent,
          total_discounted: data.payment_type_amount,
        },
      })

      this.$axios.$post('/api/notifications/v1/policy-purchased', {
        userName: `${'First name missing'} ${'Last name missing'}`,
        url: process.env.baseDomainUrl,
        policyType: 'New business',
        paymentMethod: 'Stripe',
        code: data.policy_code || 'code missing',
        price: data.payment_type_amount || 'price missing',
      })
      console.log('SET_ANNUAL_SUCCESS', data)
      commit('SET_ANNUAL_SUCCESS', data)
      commit('SET_ANNUAL_ERROR', '')
      // commit('RESET_QUOTE', resetQuote())
      // commit('RESET_PRICE')
      await this.$router.push({ path: `/dashboard`, query: { type: 'paid' } })
    } catch (_error) {
      const { data, error, status } = _error.response
      const { message } = data
      console.log('SET_ANNUAL_ERROR', error || message.error || 'Error')
      console.log('SET_ANNUAL_ERROR status', status)
      this.$toast.error(`Error payment ${error || message.error || 'Error'}`)
      commit('SET_ANNUAL_SUCCESS', false)
      commit('SET_ANNUAL_ERROR', error || message.error || 'Error')
    }

    commit('SET_ANNUAL_LOADING', false)
  },
}
